
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import SearchRow from "@/components/generic/search-row.vue";

@Component({
  components: { SearchRow },
})
export default class Buildings extends Vue {

  @Getter private envCompanyId: number | null;

  private buildingList: any[] = [];
  private totalItems: number = 0;
  private isLoading: boolean = true;
  private pagination: any = {
      search: "",
      page: 1,
      itemsPerPage: 10,
  };

  private mounted(): void {
    this.fetchFirstBuildings();
    this.initScroll();
  }

  private initScroll(): void {
    window.addEventListener("scroll", async (): Promise<void> => {
        const listElm = document.querySelector("#buildings-list");
        const currentScrollValue: number = document.documentElement.scrollTop;
        const threshold: number = listElm?.clientHeight - window.innerHeight - 1000;
        const isTargetPos: boolean = currentScrollValue > threshold;
        if (isTargetPos && !this.isLoading && !this.allBuildingsFetch) {
            await this.fetchNextBuildings();
        }
    });
  }

  private async fetchFirstBuildings(): Promise<void> {
    this.pagination.page = 1;

    await this.getBuildingsList()
      .then((data) => {
        this.buildingList = data.rows;
        this.totalItems = data.count;
      });
  }

  private async fetchNextBuildings(): Promise<void> {
    this.pagination.page += 1;

    await this.getBuildingsList()
      .then((data) => {
        if (!data.rows.length) { return; }

        this.buildingList = [
          ...this.buildingList,
          ...data.rows,
        ];
      });
  }

  get allBuildingsFetch(): boolean {
    return this.totalItems === this.buildingList.length;
  }

  private getFullAddress(item) {
      return item.Address ? `${item.Address.address || ""} ${item.Address.zipcode || ""} ${item.Address.city || ""} ` : "";
  }

  /**
   * Clicks on a row, navigates to the building page with the given item's id as a parameter.
   *
   * @param {Object} item - The clicked row item.
   * @returns {Promise} - A promise representing the navigation action.
   */
  private clickRow(item) {
    return this.$router.push({ name: "building", params: { id: item.id } });
  }

  /**
   * Retrieves the company's building list from the store.
   *
   * @private
   * @returns {Promise} A promise that resolves to the building list.
   */
  private async getBuildingsList(): Promise<{ rows: any[]; count: number }> {
    this.isLoading = true;
    return this.$store.dispatch("companies/getCompanyBuildingList", {
      companyId: this.envCompanyId,
      search: this.pagination.search || null,
      page: this.pagination.page,
      itemsPerPage: this.pagination.itemsPerPage,
      notLinkToRelay: true,
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Resets the search page to 1 and retrieves the Build Bing List.
   *
   * @returns {void}
   */
  private async searchHandler(event: { search: string }): Promise<void> {
    this.pagination.search = event.search;
    this.pagination.page = 1;
    await this.fetchFirstBuildings();
  }
}
